import React from 'react';
import { Tooltip } from 'antd';
import BaseBtn from '../../../BaseBtn';

const BaseBlock = ({ tooltipTitle, ...props }) => {
  return (
    <Tooltip title={tooltipTitle}>
      <BaseBtn {...props} />
    </Tooltip>
  );
};

export default BaseBlock;
